import _ from 'underscore';
import { FilterAgent } from '@bingads-webui/filter-agent';

function showExceededSaveLimitError(i18n, filterConfig, tabView) {
  const errMsg = i18n.getString('Error_Campaign_API_FiltersExceedsMaxCount')
    .replace('{0}', filterConfig.maxSavedFilterLimit);
  tabView.alertHelper.showAlert(errMsg);
}

export class FilterAgentManager {
  initializeFilterAgent = ({
    tabView,
    toolbar,
    filterConfig,
    filterService,
  }) => {
    const { i18n } = filterConfig;
    this.filterAgent = new FilterAgent(_.extend(filterConfig, {
      toolbarView: toolbar,
      filterService,
    }));

    this.filterAgent.on('filter-ui-change', (state) => {
      tabView.setState({
        filterBar: state.showFilterBar ? this.filterAgent.getFilterBar() : null,
        filterEditor: state.showFilterEditor ? this.filterAgent.getFilterEditor() : null,
        showToolbar: state.showToolBar,
      });
    });

    this.filterAgent.on('filter-state-changed', ({ filter }) => {
      tabView.updateViewWithFilter(filter);
    });

    this.filterAgent.on('filter-operation-failed', (errorData) => {
      if (errorData.message === 'ExceededSaveLimit') {
        showExceededSaveLimitError(i18n, filterConfig, tabView);
      } else {
        tabView.alertHelper.showUnknownError();
      }
    });

    this.filterAgent.on('filter-max-reached', () => {
      showExceededSaveLimitError(i18n, filterConfig, tabView);
    });

    return this.filterAgent;
  }
}
